const endpoint = "https://uepb.cuba-go.com"
const cpoint = "https://central-backend.cuba-go.com"

const mediapoint = `${cpoint}/electronic`
const startpoint = `${cpoint}/uep/`

export { endpoint, mediapoint, startpoint }
